import { render } from "./ResetAccount.vue?vue&type=template&id=48b49f48"
import script from "./ResetAccount.vue?vue&type=script&lang=js"
export * from "./ResetAccount.vue?vue&type=script&lang=js"

import "./ResetAccount.vue?vue&type=style&index=0&id=48b49f48&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__